import React from 'react';
import { createRoot } from 'react-dom/client';

import { Footer, Header, PageTitle } from '../_scripts/common.jsx';
import { BREADCRUMBS as parentBreadcrumbs } from '../index.jsx';

import '../_styles/default.css';
import './cv.css';


export const BREADCRUMBS = parentBreadcrumbs.concat([{
    href: '/cv',
    title: 'Curriculum Vitæ'
}]);

export function CVEntry ({id, titles, school, employer}) {
    return <li id={id}>
        {titles ?
            <div className="titles">
                {titles &&
                    titles.reduce((accumulator, currentValue, currentIndex) => {
                        if (currentIndex !== 0) {
                            accumulator.push(<br key={currentIndex + '-br'}/>);
                        }

                        if (currentValue.isPrimary === true) {
                            accumulator.push(<span key={currentIndex} className="currentTitle">
                                <span itemProp="jobTitle">{currentValue.title}</span>{' '}{currentValue.dates}
                            </span>);
                        } else {
                            accumulator.push(<span key={currentIndex + '-span'} className="formerTitle">
                                {school ? '• ' : ''}{currentValue.title}{' '}{currentValue.dates}
                            </span>);
                        }

                        return accumulator;
                    }, [])
                }
            </div>
        :
            null
        }
        {school ?
            <div itemProp="alumniOf" itemScope itemType="http://schema.org/CollegeOrUniversity">
                <a itemProp="url" target="_blank" rel="noreferrer" href={school.url}>
                    <span itemProp="legalName">
                        <span itemProp="name">{school.name}</span>
                    </span>
                </a>
            </div>
        : employer ?
            <div>
                <span itemProp={employer.isPrimary ? 'worksFor' : 'alumniOf'} itemScope itemType="http://schema.org/Corporation">
                    {employer.url ?
                        <a itemProp="url" target="_blank" rel="noreferrer" href={employer.url}>
                            <span itemProp="legalName">{employer.name}</span>
                        </a>
                        :
                        <span itemProp="legalName">{employer.name}</span>
                    }
                </span>
                <br/>
                {employer.address}
            </div>
        :
            null
        }
    </li>;
}

export const ROOT = <div id="root">
    <Header current={BREADCRUMBS[0].href}/>
    <main id="cv" vocab="http://schema.org/" itemScope itemType="http://schema.org/Person">
        <PageTitle title={BREADCRUMBS[BREADCRUMBS.length - 1].title}/>
        <address>
            <div className="name">
                <span itemProp="givenName">Corey</span> <span itemProp="additionalName">A.</span> <span itemProp="familyName">Hutton</span>
            </div>
            <br/>
            <a itemProp="url" href="https://www.cahutton.com">CAHutton.com</a>
        </address>
        <section id="work">
            <h2>
                <span>Work Experience</span>
            </h2>
            <ol>
                <CVEntry id="usnews" titles={[
                    {
                        dates: '(September 2024–Present)',
                        isFormer: false,
                        isPrimary: true,
                        title: 'Director of Technology, Health'
                    },
                    {
                        dates: '(February 2023–August 2024)',
                        isFormer: true,
                        isPrimary: false,
                        title: 'Senior Tech Manager'
                    },
                    {
                        dates: '(July 2017–February 2023)',
                        isFormer: true,
                        isPrimary: false,
                        title: 'Software Team Lead'
                    },
                    {
                        dates: '(July 2017)',
                        isFormer: true,
                        isPrimary: false,
                        title: 'Senior Software Developer'
                    },
                    {
                        dates: '(June 2014–July 2017)',
                        isFormer: true,
                        isPrimary: false,
                        title: 'Software Developer'
                    }
                ]} employer={{
                    isPrimary: true,
                    name: 'U.S. News & World Report, L.P.',
                    url: 'https://www.usnews.com'
                }}/>
                <CVEntry id="flarecode" titles={[
                    {
                        dates: '(September 2011–April 2014)',
                        isFormer: true,
                        isPrimary: true,
                        title: 'Developer'
                    }
                ]} employer={{
                    isPrimary: false,
                    name: 'Flare Code, Inc.'
                }}/>
            </ol>
        </section>
        <section id="education">
            <h2>
                <span>Education</span>
            </h2>
            <ol>
                <CVEntry id="au" titles={[
                    {
                        dates: '(August 2021)',
                        isFormer: true,
                        isPrimary: true,
                        title: 'Graduate Certificate in Data Science'
                    }
                ]} school={{
                    name: 'American University',
                    url: 'https://www.american.edu/'
                }}/>
                <CVEntry id="ou" titles={[
                    {
                        dates: '(March 2011)',
                        isFormer: true,
                        isPrimary: true,
                        title: 'Bachelor of Science in Computer Science'
                    },
                    {
                        dates: null,
                        isFormer: true,
                        isPrimary: false,
                        title: 'Computer Science Major'
                    },
                    {
                        dates: '(June 2010)',
                        isFormer: true,
                        isPrimary: true,
                        title: 'Bachelor of Arts'
                    },
                    {
                        dates: null,
                        isFormer: true,
                        isPrimary: false,
                        title: 'Linguistics Major'
                    },
                    {
                        dates: null,
                        isFormer: true,
                        isPrimary: false,
                        title: 'Certificate in Teaching English as a Second or Foreign Language'
                    },
                    {
                        dates: '(Mar 2010)',
                        isFormer: true,
                        isPrimary: true,
                        title: 'Bachelor of Science'
                    },
                    {
                        dates: null,
                        isFormer: true,
                        isPrimary: false,
                        title: 'Mathematics Major'
                    }
                ]} school={{
                    name: 'Ohio University',
                    url: 'https://www.ohio.edu'
                }}/>
            </ol>
        </section>
    </main>
    <Footer breadcrumbs={BREADCRUMBS}/>
</div>;

const root = createRoot(document.getElementById('rootContainer'));
root.render(ROOT);
